<template>
  <div>
    <!-- {{ blogs }} -->
    <table class="table table-striped mt-2">
      <thead class="" style="background-color: var(--coredarkcolor); color: var(--corelightcolor);">
        <tr class="">
          <th scope="col">Title</th>
          <th scope="col">Date</th>
          <th scope="col">Status</th>
          <!-- <th scope="col">Numero de Celular</th> -->
          <!-- <th scope="col">Categoría</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="blog in filteredBlogs" :key="blog.id" @click="showBlogModal(blog)" style="cursor: pointer;">
        <!-- <tr v-for="user in filteredCandidates" :key="user.id" @click="deleteUser(user.id)" style="cursor: pointer;"> -->
          <td>
            {{ blog.title }}
          </td>
          <td>
            {{ (new Date(blog.created_date)).toDateString() }}
          </td>
          <td>
            <div v-if="!blog.published">
              <strong>Not Published</strong>
            </div>
            <div v-else>
              Published
            </div>
          </td>
          <!-- <td>
            <button class="btn btn-danger" @click="deleteUser(user)">Delete</button>
          </td> -->
        </tr>
      </tbody>
    </table>

    <modal name="blog-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <button v-if="!blog.published" class="mylisting-button dark-button mb-2" @click="publish()">Publish</button>
        <button v-else class="mylisting-button dark-button mb-2" @click="unpublish()">Unpublish</button>

        <!-- <img :src="blog.hero_image" alt="" width="100%">
        <h1 class="mt-3">{{ blog.title }}</h1>
        <p class="mt-3">{{ new Date(blog.created_date).toDateString() }}</p>
        <hr>
        <pre v-html="blog.content"></pre> -->
        <app-blog-post :id="blog.id"></app-blog-post>

        <hr>
        <button v-if="!blog.published" class="mylisting-button dark-button" @click="publish()">Publish</button>
        <button v-else class="mylisting-button dark-button" @click="unpublish()">Unpublish</button>
        <button class="mylisting-button secondary-button" @click="hideBlogModal()">Cancel</button>
      </div>
    </modal>

  </div>
</template>

<script>
import axios from 'axios'

import BlogPost from '../blog/BlogPost'

export default {
  components: {
    appBlogPost: BlogPost,
  },
  data() {
    return {
      blogs: [],
      blog: {},
    }
  },
  computed: {
    filteredBlogs() {
      return this.blogs
    },
  },
  created() {
    this.getBlogs()
  },
  methods: {
    getBlogs() {
      axios.get('/api/blogposts/?agency='+this.$store.getters.agencyID)
        .then(res => {
          console.log(res)
          this.blogs = res.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    showBlogModal(blog) {
      this.blog = blog
      this.$modal.show('blog-modal')
    },
    hideBlogModal() {
      this.$modal.hide('blog-modal')
    },
    publish() {
      axios.patch('/api/blogposts/'+this.blog.id.toString()+'/', {
        published: true,
      })
        .then(res => {
          console.log(res)
          this.getBlogs()
          this.hideBlogModal()
        })
        .catch(error => {
          console.log(error)
        })
    },
    unpublish() {
      axios.patch('/api/blogposts/'+this.blog.id.toString()+'/', {
        published: false,
      })
        .then(res => {
          console.log(res)
          this.getBlogs()
          this.hideBlogModal()
        })
        .catch(error => {
          console.log(error)
        })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/Blog.vue